export default __webpack_public_path__ + "static/media/list_main_15_2.fcad110c.jpg";